import React from "react";
import ReactDOM from 'react-dom'
import moment from 'moment';
import ReactTable from "react-table";
import Button from "components/CustomButtons/Button.js";
import EmailIcon from '@material-ui/icons/Email';
import { CSVLink, CSVDownload } from 'react-csv';
import EmailButton from 'components/CustomButtons/EmailButton'
import UserButton from 'components/CustomButtons/UserButton'
import CancelReservationButton from 'components/CustomButtons/CancelReservationButton'
import CheckInButton from 'components/CustomButtons/CheckInButton'
import { useSelector } from 'react-redux';


function monthNumberToString(monthNumber) {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const d = new Date();
  const name = monthNames[monthNumber - 1];
  return [name, (d.getMonth() === (monthNumber - 1))]
}

function ClassAttendanceTable(props) {
  const { selected_class, reservations, isLoading, onCancelReservation } = props;
  const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  });
  const data = reservations.sort((a, b) => {
    if (a.objectSnapshot && b.objectSnapshot) {
      return b.objectSnapshot.start_time - a.objectSnapshot.start_time
    } else {
      return 0
    }
  }).map(val => {

    // const created = (val.objectSnapshot ? (val.objectSnapshot.start_time ? val.objectSnapshot.start_time : 0) : 0) * 1000;

    var studentInfo = {
      name: "-",
      username: "-",
      birthdayMonth: "Unknown",
      injuries: "",
      specialRequests: "",
      email: "-",
      region: "The Best Place Ever",
      userId: ""
    }

    // Support for widget users.. 
    if (val.customer_name) {
      studentInfo.name = val.customer_name;
    }
    if (val.customer_email) {
      studentInfo.email = val.customer_email;
    }

    const user = val.user;
    if (user) {
      if (user.platformID) {
        studentInfo.userId = user.platformID
      }
      if (user.firstName) {
        studentInfo.name = user.firstName;
      }
      if (user.lastName) {
        studentInfo.name = studentInfo.name + " " + user.lastName
      }
      if (user.username) {
        studentInfo.username = user.username;
      }
      if (user.birthdayMonth) {
        studentInfo.birthdayMonth = (user.birthdayMonth !== "") ? user.birthdayMonth : "-";
        // studentInfo.birthdayMonth = 4;
      }
      if (user.injuries && user.injuries !== "") {
        studentInfo.injuries = user.injuries;
      }
      if (user.specialRequests && user.specialRequests !== "") {
        studentInfo.specialRequests = user.specialRequests;
      }
      if (user.email) {
        studentInfo.email = user.email;
      }
      if (user.region) {
        studentInfo.region = user.region;
      }
    }

    if (val.specialRequests && val.specialRequests !== "") {
      studentInfo.specialRequests = val.specialRequests
    }

    var student_name = "";
    var email = "";
    if (val.user && val.user.firstName) {
      student_name = val.user.firstName + " " + val.user.lastName;
      email = val.user.email
    } else if (val.email) {
      student_name = "Unknown"
      email = val.email
    } else {
      student_name = "Unknown"
      email = "Unknown"
    }
    var object_id = "";
    var object_name = "";
    if (val.objectSnapshot) {
      object_id = val.id;
      object_name = val.objectSnapshot.class_name
    }
    let key = val.platformID;
    let date = moment(val.created * 1000).format('MMMM Do, h:mm a')

    let checkInButton = (
      <CheckInButton
        checkedIn={val.checkedIn ?? false}
        onCheckIn={() => {
          if (props.onCheckIn) {
            props.onCheckIn(val)
          }
        }}
      />
    )

    var reservationType = ""
    if (val.canceled) {
      reservationType = 'CANCELED'
    } else if (val.couponCodeResponse) {
      reservationType = (<>
        <span>{val.reservationType ?? "Drop-In"}</span><br></br>
        <span>{val.couponCodeResponse.code}</span>
      </>)
    } else {
      reservationType = (<>
        <span>{val.reservationType ?? "Drop-In"}</span>
        <span className={val.reservationType === 'drop in' ? '' : 'd-none'}><br></br>{val.reservationType === 'drop in' ? currencyFormatter.format(val.payment ?? 0) : null}</span><br></br>
      </>)
    }

    const actions = (
      <div className="d-flex d-row justify-content-end">


        {!val.canceled && (
          <CancelReservationButton
            onCancel={onCancelReservation}
            reservationId={val.id}
            reservationData={val}
          />
        )}
        <EmailButton
          email={studentInfo.email}
        />



      </div>
    )

    return {
      id: key,
      checkedIn: val.checkedIn ?? false,
      checkInStatus: checkInButton,
      userId: studentInfo.userId,
      type: reservationType,
      user: user ? (<UserButton user={user} />) : studentInfo?.name,
      student_name: studentInfo.name,
      username: studentInfo.username,
      region: studentInfo.region,
      birthdayMonth: studentInfo.birthdayMonth,
      injuries: studentInfo.injuries,
      specialRequests: studentInfo.specialRequests,
      email: studentInfo.email,
      status: val.status ? val.status : "Unknown",
      agree_to_marketing: (val.agreeToBeContacted === "true" || val.agreeToBeContacted === true) ? true : false,
      injuriesRequests: ((studentInfo.injuries && studentInfo.injuries !== "") || (studentInfo.specialRequests && studentInfo.specialRequests !== "")) ? (
        <div>
          {studentInfo?.injuries !== "" && (
            <p>{studentInfo.injuries}</p>
          )}
          {studentInfo?.specialRequests !== "" && (
            <p>{studentInfo.specialRequests}</p>
          )}
        </div>
      ) : (<>None</>),
      actions: actions
    };
  })

  function handleExport() {
    const headers = [
      { label: "User ID", key: "userId" },
      { label: "Client Name", key: "student_name" },
      { label: "Client Email", key: "email" },
      { label: "Type", key: "type" },
      { label: "Marketing Opt-in", key: "agree_to_marketing" },
      { label: "Current Status", key: "status" },
      { label: "Username", key: "username" },
      { label: "Region", key: "region" },
      { label: "Birthday Month", key: "birthdayMonth" },
      { label: "Injuries", key: "injuries" },
      { label: "Special Requests", key: "specialRequests" }
    ]
    const cleanedData = data.map(val => {
      return {
        userId: val.userId,
        student_name: val.student_name,
        email: val.email,
        type: val.type,
        agree_to_marketing: val.agree_to_marketing,
        status: val.status,
        username: val.username,
        region: val.region,
        birthdayMonth: val.birthdayMonth,
        injuries: val.injuries,
        specialRequests: val.specialRequests
      }
    })
    const element = (<CSVDownload filename={`${selected_class.class_name}.csv`} data={cleanedData} headers={headers} target="_blank" />);

    ReactDOM.render(element, document.querySelector('#export-reservations-div'));
  }


  return (
    <div>
      <div className="d-none d-sm-block">

        <div className="d-flex flex-row-reverse">
          <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
          <div id='export-reservations-div'></div>
        </div>

      </div>
      <ReactTable
        loading={isLoading}
        data={data}
        filterable
        columns={[
          {
            Header: "Status",
            accessor: "checkInStatus"
          },
          // {
          //   Header: "Status",
          //   accessor: "checkedIn"
          // },
          // {
          // Header: "res Id",
          // accessor: "id",
          // sort: 'desc'
          // },
          // {
          // Header: "User ID",
          // accessor: "userId",
          // sort: 'desc'
          // },
          {
            Header: "Name",
            accessor: "user",
            sort: 'desc'
          },
          // {
          // Header: "Username",
          // accessor: "username",
          // sort: 'desc'
          // },
          {
            Header: "Type",
            accessor: "type",
            sort: 'desc',
            width: 160
          },
          {
            Header: "Region",
            accessor: "region",
            sort: 'desc'
          },
          {
            Header: "Birthday Month",
            accessor: "birthdayMonth",
            Cell: row => {
              const monthValue = monthNumberToString(row.value);
              if (monthValue[1]) {
                return (<span>🎂 {monthValue[0]}</span>);
              } else {
                return (<span>{monthValue[0]}</span>);
              }
            }
          },
          {
            Header: "Injuries & Requests",
            accessor: "injuriesRequests"
          },
          // {
          // Header: "Special Requests",
          // accessor: 'specialRequests'
          // },
          // {
          // Header: "Class Time",
          // accessor: "class_time",
          // filterable: false,
          // sort: 'desc',
          // Cell: row => <span>{moment(row.value * 1000).format('MMMM Do, h:mm a')}</span>
          // },
          // {
          // Header: "Client Name",
          // accessor: "student_name"
          // },
          {
            Header: "Email",
            accessor: "email"
          },
          {
            Header: "Actions",
            accessor: "actions",
            sortable: false,
            filterable: false,
            width: 100
          }
        ]}
        defaultPageSize={10}
        showPaginationTop={false}
        showPaginationBottom={true}
        className="-highlight"
      />
    </div>
  );
}

export default ClassAttendanceTable;